import { MagicCard, MagicContainer } from '@/shared/components/animation/magic-container';
import { Article } from '@/shared/components/article';
export const ThemesSpeakingClubs = () => {
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8">Темы разговорных клубов</h2>

      <MagicContainer className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4 xl:gap-10">
        <MagicCard>
          <div>
            <h3 className="mb-4 h-8 header-h3 sm:h-12 lg:h-14">Networking and&nbsp;self-presentation</h3>

            <p className="text-sm sm:text-base">
              Налаживаем бизнес коммуникацию, учимся представлять себя и&nbsp;свою компанию
            </p>
          </div>
        </MagicCard>

        <MagicCard>
          <div>
            <h3 className="mb-4 h-8 header-h3 sm:h-12 lg:h-14">How to&nbsp;de-stress</h3>

            <p className="text-sm sm:text-base">
              Обсуждаем причины стресса, способы расслабления, вещи, которые мы&nbsp;можем и&nbsp;не&nbsp;можем
              контролировать в&nbsp;жизни, практикуем вокабуляр
            </p>
          </div>
        </MagicCard>

        <MagicCard>
          <div>
            <h3 className="mb-4 h-8 header-h3 sm:h-12 lg:h-14">Catching up made easy</h3>

            <p className="text-sm sm:text-base">
              Быстрыми сообщениями в&nbsp;рабочих и&nbsp;неформальных чатах, обсуждаем правила переписки
            </p>
          </div>
        </MagicCard>

        <MagicCard>
          <div>
            <h3 className="mb-4 h-8 header-h3 sm:h-12 lg:h-14">This is&nbsp;why you procrastinate</h3>

            <p className="text-sm sm:text-base">
              Обсуждаем причины прокрастинации, смотрим видео и&nbsp;работаем с&nbsp;фразовыми глаголами
            </p>
          </div>
        </MagicCard>
      </MagicContainer>
    </Article>;
};